const $ = window.jQuery
const $window = window.$window || $(window)

/**
 * Intercept clicks on any anchor tag and if the anchor is linking to an on page ID, animate the scroll to the targeted
 * element.
 *
 * This only works if the href contains a value beginning with '#'. e.g; #about-section
 *
 * If the clicked element has a `data-toggle=xxx` attribute, it won't be handled
 */
const AnimateOnPageLinks = {

    duration: 200,
    offset: 0,

    /**
     * Initialise functionality
     */
    init() {
        
        let vm = this

        vm.attachListeners($(document))

        // Listen to modal changes
        $(window).on('modal-change', e => {
            const modalId = e.detail
            if (modalId === false) return

            setTimeout(() => {
                const $modal = $(`.modal-container[data-modal-id="${modalId}"]`)
                vm.attachListeners($modal)
            }, 100)

        })

    },

    /**
     * 
     * @param {jQuery set of elements} $container Container containing links to attach listeners to
     */
    attachListeners($container) {

        $container.find('a').on('click', (e) => {

            let $link = $(e.target).closest('a')
            if (this.isExcluded($link)) return

            let href = $link.attr('href')
            if (!this.linkIsTargetingPageAnchor(href)) return

            let $targetEl = $(href)
            let $parentEl = $targetEl.closest('html, .modal')
            if (!$targetEl.length) return

            e.preventDefault()

            let offset      = $targetEl.data('scroll-to-offset') || this.offset
            let scrollTop   = $targetEl.position().top + offset

            if ($parentEl.is('html')) scrollTop -= $('header#header').outerHeight()  // subtract any additional height considerations (e.g. height of sticky header)

            $parentEl.animate(
                { scrollTop }, 
                this.duration, 
                'swing', 
                () => $targetEl.trigger('scrolled_to')
            )

        })

    },

    /**
     * Whether we should ignore the clicked element
     * @param {jQuery set of elements} $selector 
     */
    isExcluded($selector) {
        return !!$selector.data('toggle')
    },

    /**
     * Whether target url is a page anchor
     * @param {String} link 
     */
    linkIsTargetingPageAnchor(link) {
        return /^#/.test(link)
    }

}

export default AnimateOnPageLinks;